export {buildConfig} from "./buildConfig"